export default "__VITE_ASSET__BYH8M4s1__"